var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import DataTree from "~/components/common/data-tree.vue";
import { ResourceService } from "~/services/management-service/resource.service";
import AddResource from "~/components/system-manage/resource-manage/add-resource.vue";
import ModifyResource from "~/components/system-manage/resource-manage/modify-resource.vue";
import { CommonService } from "~/utils/common.service";
var ResourceManage = /** @class */ (function (_super) {
    __extends(ResourceManage, _super);
    function ResourceManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.resourceData = [];
        _this.resourceDataTree = [];
        _this.treeDefaultSelection = [];
        _this.parentId = "";
        _this.resource = {
            id: "",
            parentId: "",
            icon: "",
            name: "",
            resoSort: "",
            type: "",
            url: ""
        };
        _this.resourceObj = {};
        _this.dialog = {
            modify: false,
            batchRole: false,
            roleAllot: false,
            facility: false,
            batchFacility: false,
            addResource: false,
            editOrganizeFlag: false,
            addOrganizeFlag: false,
            batchLevel: false
        };
        return _this;
    }
    ResourceManage.prototype.refresh = function (formName) {
        var _this = this;
        this.$nextTick(function () {
            var form = _this.$refs[formName];
            form.refresh();
        });
    };
    /**
     * 修改机构open事件(获取机构)
     */
    ResourceManage.prototype.getOragnize = function () {
        var _this = this;
        this.$nextTick(function () {
            var edit = _this.$refs["edit"];
            edit.refresh();
        });
    };
    ResourceManage.prototype.dialogOpen = function () {
        var _this = this;
        this.$nextTick(function () {
            var addUser = _this.$refs["add-dept"];
            // addUser.refresh(this.dept);
        });
    };
    ResourceManage.prototype.refreshData = function () {
        var _this = this;
        var resourceModelRequest = this.resource;
        this.resourceService.getResourceAllPage(resourceModelRequest, this.pageService).subscribe(function (data) {
            _this.resourceData = data;
        });
    };
    /**
     * 获取当前树选择项
     */
    ResourceManage.prototype.getCheckedNodes = function (value) {
        this.resource.id = value.id;
        this.resource.parentId = value.parentId;
        this.parentId = value.id;
        this.refreshData();
    };
    ResourceManage.prototype.created = function () {
        this.getResourceAll();
    };
    ResourceManage.prototype.mounted = function () {
    };
    ResourceManage.prototype.deleteResource = function (row) {
        // this.$confirm(`您确定要删除该资源及下级吗？`, '提示', {
        this.$confirm("\u5371\u9669\u7CFB\u6570\u5927\uFF0C\u4E0D\u5141\u8BB8\u4F7F\u7528", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(function () {
            // this.resourceService.deleteResourceById(row.id)
            //     .subscribe((data) => {
            //         this.$message.success('删除成功');
            //         this.refreshData();
            //     });
        });
    };
    /**
     * 加载资源并加载树
     */
    ResourceManage.prototype.getResourceAll = function () {
        var _this = this;
        this.resourceService.getResourceAll().subscribe(function (data) {
            var treeDataTmp = CommonService.generateTreeData(data, {
                keyName: "id",
                parentKeyName: "parentId",
                sortKey: "resoSort"
            });
            treeDataTmp.forEach(function (e) { return e.parent = 0; });
            var arr = [
                {
                    id: -1,
                    name: "贷后催收系统4.5",
                    parent: 0,
                    children: treeDataTmp
                }
            ];
            _this.resourceDataTree = arr;
        });
    };
    __decorate([
        Dependencies(PageService)
    ], ResourceManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(ResourceService)
    ], ResourceManage.prototype, "resourceService", void 0);
    ResourceManage = __decorate([
        Auth(2312),
        Layout("workspace"),
        Component({
            components: {
                DataTree: DataTree,
                AddResource: AddResource,
                ModifyResource: ModifyResource
            }
        })
    ], ResourceManage);
    return ResourceManage;
}(Vue));
export default ResourceManage;
